module.exports = __webpack_public_path__ + "static/media/space_jam2.71b7db39.gif";